<template>
  <div class="bottom_tree_table">
    <div class="bottom_left">
      <div class="left_tree">
        <div style="padding:20px">
          <el-input v-model="filterText" placeholder="输入关键字进行过滤" size="small" clearable />
        </div>
        <org-tree ref="orgTree" :filter-text="filterText" @orgcurrent="currentOrgChangeHandler"></org-tree>
      </div>
    </div>
    <div class="bottom_right">
      <div class="right_button" style="display: inline-block">
        <el-input v-model="searchQuery.keyword" placeholder="请输入登录名或姓名" size="small"
          style="width: 200px;margin-left:10px" clearable @input="getPersonList(1)">
          <template #prefix>
            <i class="el-icon-search el-input__icon" @click="getPersonList(1)" />
          </template>
        </el-input>
      </div>
      <div class="right_table">
        <orgPersonTable :person-table="personTable" :type="2"></orgPersonTable>
      </div>
      <page :page="page" class="page-2" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
      </page>
    </div>
  </div>
</template>
<script>
import orgFrameworkConfig from "@/CommonDP/service/org-service";
import orgTree from "@/CommonDP/components/structure/orgTree.vue";
import page from "@/CommonDP/components/paging";
import orgPersonTable from "@/CommonDP/components/structure/orgPersonTable.vue";
import { getEnterpriseId } from "@/CommonDP/utils/auth";
export default {
  components: { orgTree, orgPersonTable, page },
  data() {
    return {
      page: {
        pageNum: 1,
        pageSize: 20,
        totalCount: 0
      },
      currentID: {},
      personTable: [],
      searchQuery: {
        keyword: ""
      },
      userID: undefined,
      filterText: ""
    };
  },
  computed: {
    enterpriseId() {
      return getEnterpriseId("enterpriseId");
    }
  },

  methods: {
    currentOrgChangeHandler(val) {
      this.currentID = val;
      this.getPersonList(1);
      this.userID = undefined;
    },
    handleCurrentChange(val) {
      this.getPersonList(val);
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getPersonList(1);
    },
    getPersonList(index) {
      const deptId = this.currentID.deptId;
      const {
        page: { pageSize },
        searchQuery: { keyword },
        enterpriseId
      } = this;
      var params = {
        deptId,
        keyword,
        pageNum: index,
        pageSize,
        enterpriseId,
        isQueryAll: 1
      };
      orgFrameworkConfig.orgUserList(params).then(({ data, totalCount, pageNum }) => {
        this.page.pageNum = pageNum;
        this.page.totalCount = totalCount;
        this.personTable = data;
        this.userID = undefined;
        this.isSignature = undefined;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
$top-button-height: 52px;
$middle-height: 30px;
$left-width: 280px;
.bottom_tree_table {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  min-width: 1080px;
  .bottom_left {
    position: absolute;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    width: $left-width;
    padding-left: 12px;
    border-right: 1px solid #ebefff;
    .left_tree {
      overflow: auto;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 10px;
      right: 0;
      display: flex;
      flex-direction: column;
    }
  }
  .bottom_right {
    position: relative;
    height: 100%;
    margin-left: $left-width + 20px;
    .right_button {
      padding: 20px 0;
    }
    .right_table {
      position: absolute;
      top: $top-button-height + 20px;
      left: 10px;
      bottom: 40px;
      right: 10px;
    }
  }
}

.page-2 {
  position: absolute;
  bottom: 0;
  right: 20px;
  height: 34px;
  padding: 2px;
}
</style>
